import { Component } from "@angular/core";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { LogoComponent } from "@m19-board/shared/logo/logo.component";

@Component({
  selector: "app-account-link-illustration",
  standalone: true,
  imports: [CommonModule, LogoComponent, NgOptimizedImage],
  templateUrl: "./account-link-illustration.component.html",
})
export class AccountLinkIllustrationComponent {}
